"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _finance = require("@/api/finance");
var _permission = require("@/utils/permission");
var _download = _interopRequireDefault(require("@/plugins/download"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
//import detailsFrom from '@/views/order/orderDetail'
// 权限判断函数
var _default = exports.default = {
  filters: {
    transactionTypeFilter: function transactionTypeFilter(status) {
      var statusMap = {
        pay_order: '订单支付',
        refund_order: '订单退款',
        recharge_user: '用户充值',
        yue_pay: '余额支付',
        merchant_collect: '商户分账',
        brokerage: '分佣',
        system: '系统'
      };
      return statusMap[status];
    }
  },
  data: function data() {
    return {
      orderId: '',
      tableData: {
        data: [],
        total: 0
      },
      listLoading: true,
      exportLoading: false,
      tableFrom: {
        orderNo: '',
        dateLimit: '',
        page: 1,
        limit: 20
      },
      timeVal: [],
      fromList: this.$constants.fromList,
      selectionList: [],
      ids: '',
      tableFromLog: {
        page: 1,
        limit: 10
      },
      tableDataLog: {
        data: [],
        total: 0
      },
      LogLoading: false,
      dialogVisible: false,
      evaluationStatusList: [{
        value: 1,
        label: '已回复'
      }, {
        value: 0,
        label: '未回复'
      }],
      cardLists: [],
      orderDatalist: null
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:finance:funds:flow'])) this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 选择时间
    selectChange: function selectChange(tab) {
      this.tableFrom.dateLimit = tab;
      this.timeVal = [];
      this.getList(1);
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.getList(1);
    },
    // 导出
    exportRecord: function exportRecord() {
      var _this = this;
      this.exportLoading = true;
      (0, _finance.capitalFlowExportApi)(this.tableFrom).then(function (res) {
        if (res && res.fileName) {
          if (/^https?:\/\//i.test(res.fileName)) {
            _download.default.url(res.fileName);
          } else {
            _download.default.name(res.fileName);
          }
        } else {
          _this.$message.warning('导出文件不存在');
        }
      }).catch(function (res) {
        if (res && !res.__requestMessageShown) _this.$message.error(res.message);
      }).finally(function () {
        _this.exportLoading = false;
      });
    },
    // 导出列表
    getExportFileList: function getExportFileList() {
      this.$refs.exportList.exportFileList();
    },
    // 列表
    getList: function getList(num) {
      var _this2 = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      (0, _finance.capitalFlowLstApi)(this.tableFrom).then(function (res) {
        _this2.tableData.data = res.list;
        _this2.tableData.total = res.total;
        _this2.listLoading = false;
      }).catch(function (res) {
        if (res && !res.__requestMessageShown) _this2.$message.error(res.message);
        _this2.listLoading = false;
      });
    },
    reset: function reset() {
      this.tableFrom = {
        orderNo: '',
        dateLimit: '',
        page: 1,
        limit: 20
      };
      this.getList();
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList(1);
    }
  }
};